"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFeemodifierFrozen = exports.IFeemodifierInactive = exports.IFeemodifierMarkupum = void 0;
var IFeemodifierMarkupum;
(function (IFeemodifierMarkupum) {
    IFeemodifierMarkupum[IFeemodifierMarkupum["THE_MARKUP_IS_A_FIXED_AMOUNT_SPECIFIED_IN_THE_MARKUPAMOUNT_FIELD_AS_AN_INTEGER_IN_CENTS_1"] = 1] = "THE_MARKUP_IS_A_FIXED_AMOUNT_SPECIFIED_IN_THE_MARKUPAMOUNT_FIELD_AS_AN_INTEGER_IN_CENTS_1";
    IFeemodifierMarkupum[IFeemodifierMarkupum["THE_MARKUP_IS_A_PERCENTAGE_OF_THE_FEE_AMOUNT_SPECIFIED_IN_THE_MARKUPAMOUNT_FIELD_IN_BASIS_POINTS_2"] = 2] = "THE_MARKUP_IS_A_PERCENTAGE_OF_THE_FEE_AMOUNT_SPECIFIED_IN_THE_MARKUPAMOUNT_FIELD_IN_BASIS_POINTS_2";
    IFeemodifierMarkupum[IFeemodifierMarkupum["DEFAULT_3"] = 3] = "DEFAULT_3";
})(IFeemodifierMarkupum = exports.IFeemodifierMarkupum || (exports.IFeemodifierMarkupum = {}));
var IFeemodifierInactive;
(function (IFeemodifierInactive) {
    IFeemodifierInactive[IFeemodifierInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IFeemodifierInactive[IFeemodifierInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IFeemodifierInactive = exports.IFeemodifierInactive || (exports.IFeemodifierInactive = {}));
var IFeemodifierFrozen;
(function (IFeemodifierFrozen) {
    IFeemodifierFrozen[IFeemodifierFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IFeemodifierFrozen[IFeemodifierFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IFeemodifierFrozen = exports.IFeemodifierFrozen || (exports.IFeemodifierFrozen = {}));
